"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_STATUSES = void 0;
const graphql_1 = require("../../../__generated__/graphql");
// valid = manually asserted
exports.VALID_STATUSES = [graphql_1.ProductAttributeStatus.InStrategy, graphql_1.ProductAttributeStatus.Valid];
